import React from 'react';
import { useTheme } from 'styled-components';

import vppGraphicLight from 'static/vpp-enrollment-graphic.light.svg';
import vppGraphicDark from 'static/vpp-enrollment-graphic.dark.svg';
import { VPPGraphicImg } from './VPPEnrollmentGraphic.styles';

export function VPPEnrollmentGraphic() {
  const theme = useTheme();

  return (
    <VPPGraphicImg
      alt="vpp graphic"
      src={theme.name === 'darkTheme' ? vppGraphicDark : vppGraphicLight}
    />
  );
}

export default VPPEnrollmentGraphic;
